import { InfoServer } from './InfoServer';
import { FactoryInfoServer } from './factory/FactoryInfoServer';
/**
 * Implementa a interface de URL, para criar a url de conexão com o servidor
 */
export class Url {
    constructor(params) {
        this._id = params.id;
        if (params.environment instanceof InfoServer) {
            this._infoServer = params.environment;
        }
        else {
            this._infoServer = FactoryInfoServer.buildInfoServer(params.environment);
        }
        this._pathParams = params.pathParams;
        this._filter = params.filter;
    }
    get id() {
        return this._id;
    }
    set id(id) {
        this._id = id;
    }
    get infoServer() {
        return this._infoServer;
    }
    set infoServer(infoServer) {
        this._infoServer = infoServer;
    }
    get pathParams() {
        return this._pathParams;
    }
    set pathParams(pathParams) {
        this._pathParams = pathParams;
    }
    get filter() {
        return this._filter;
    }
    set filter(filter) {
        this._filter = filter;
    }
    buildUrl() {
        return `${this.infoServer.protocol}://${this.infoServer.host}:${this.infoServer.port}/${this.infoServer.context}/${this.infoServer.apiroot}/${this.substituirData(this.id)}`
            + (this.filter ? this.filter.buildFilters() : "");
    }
    substituirData(id) {
        if (!this.pathParams)
            return id;
        for (let key in this.pathParams.data) {
            id = id.replace(`:${key}`, this.pathParams.data[key]);
        }
        return id;
    }
}
